import APSlidingMenu from "./APSlidingMenu";

export { APSlidingMenu };

export default APSlidingMenu;
